import { render } from "./adjustment.vue?vue&type=template&id=7a1f3f8e&scoped=true"
import script from "./adjustment.vue?vue&type=script&lang=js"
export * from "./adjustment.vue?vue&type=script&lang=js"

import "./adjustment.vue?vue&type=style&index=0&id=7a1f3f8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a1f3f8e"

export default script